import React from "react";
import "./ticketDetail.style";
import { Grid } from '@mui/material';
import { NOT_APPLICABLE } from '../../../constants/originalState';

export interface IAssignmentErrorProps {
  infoTicket: any,
  locale: any
};

const AssignmentError = (props: IAssignmentErrorProps) => {
  const { infoTicket, locale } = props;
  const variableInfo = infoTicket.variables;
  const reasonSelected = {
    'return-device': locale?.return_device,
    'belonged-previous-employee': locale?.belonged_previous_employee,
    'never-had-device': locale?.never_had_device,
    'other-reason': locale?.other_reason,
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <p className="ttl-col-desc">{locale?.reportedAs}</p>
        <p className="value-info" id="lbl-assignmenterror-reason_selected">{reasonSelected[variableInfo?.json_storage?.reason_selected] || NOT_APPLICABLE}</p>
      </Grid>
      <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{locale?.deviceReported}</p>
        <p className="value-info" id="lbl-assignmenterror-serial_number">
          <strong>{locale?.serialNumber}:</strong> {variableInfo?.asset?.serial_number || NOT_APPLICABLE}
        </p>
        <p className="value-info" id="lbl-assignmenterror-model">
          <strong>{locale?.modelName}:</strong> {variableInfo?.asset?.model || NOT_APPLICABLE}
        </p>
      </Grid>
    </Grid>
  );
};

export default AssignmentError;